import './App.css';
import {Routes, Route, useLocation, Navigate} from "react-router-dom"
import {AnimatePresence} from "framer-motion"

import NavBar from "./components/NavBar";
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Work from "./components/Work";
import Activities from "./components/Activities";
import ActivityStory from "./components/ActivityStory";


function App() {

    const location = useLocation();


    return (
        <div>
            <NavBar className={"navigation"}/>
            <AnimatePresence mode={"sync"}>
                <Routes location={location} key={location.pathname}>
                    <Route index element={<Home />}/>
                    <Route path={"/activities"} element={<Activities/>}/>
                    <Route path={"/activities/:id"} element={<ActivityStory/>}/>
                    {/* Old bookmarks / links keep working */}
                    <Route path={"/schedule"} element={<Navigate to="/activities" replace/>}/>
                    <Route path={"/about"} element={<About/>}/>
                    <Route path={"/work"} element={<Work/>}/>
                    <Route path={"/contact"} element={<Contact/>}/>
                </Routes>
            </AnimatePresence>
        </div>
  );
}

export default App;
